import React, { useState, useEffect, useCallback } from "react";
import {
  Routes,
  Route,
  Link,
  useLocation,
  useNavigate,
  Navigate,
} from "react-router-dom";
import { useMediaQuery, Container, Box } from "@mui/material";
import MyWeddings from "./Components/MyWeddings";
import Profile from "./Components/Profile/Profile";
import Credits from "./Components/Credits/Credits";
import AdminPanel from "./Components/AdminPanel/AdminPanel";
import TermsAndConditions from "./Components/TermsAndConditions/TermsAndConditions";
import Header from "../../Components/Header";
import ADS from "./Components/ADS";
import AiPlanner from "./Components/Chatbot";
import { styled } from "@mui/material/styles";
import HomeScreen from "./Components/HomeScreen";

const MainContent = styled(Box)(() => ({
  paddingTop: "120px",
  minHeight: "calc(100vh - 120px)",
  width: "100%",
  position: "relative",
  overflow: "hidden",
}));

const ContentContainer = styled(Container)(() => ({
  height: "100%",
  position: "relative",
  margin: "0 auto",
}));

const Home = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isMobileOrTablet = useMediaQuery("(max-width: 960px)");
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const [tokenExpired, setTokenExpired] = useState(false);

  const decodeToken = (token) => {
    const base64Url = token.split(".")[1]; // Get the payload part of the token
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/"); // Replace URL-specific characters
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(jsonPayload);
  };

  const getExpirationTime = useCallback((token) => {
    const decodedToken = decodeToken(token);
    return decodedToken.exp * 1000; // Convert seconds to milliseconds
  }, []);

  const logOutUser = () => {
    setTokenExpired(true);
  };

  useEffect(() => {
    // Session timeout logic
    const token = window.localStorage.getItem("Token");
    if (token) {
      const expirationTime = getExpirationTime(token);
      const currentTime = Date.now();
      const timeUntilExpiration = expirationTime - currentTime;

      if (timeUntilExpiration > 0) {
        const timeoutId = setTimeout(logOutUser, timeUntilExpiration);

        return () => clearTimeout(timeoutId); // Clear the timeout if the component unmounts
      } else {
        logOutUser(); // Token already expired
      }
    }
  }, [getExpirationTime]);

  const handleTabChange = (path) => {
    navigate(path);
  };

  const currentFullPath = location.pathname + location.search;

  return (
    <div className="home-wrapper">
      {tokenExpired ? (
        <>
          <div className="overlay mobile-overlay"></div>
          <div className="session-expire-modal">
            <h1>Session Expired</h1>
            <p>
              Your session has expired. To continue using WeddinglyAi, please
              sign in again.
            </p>
            <Link className="link-back" to="/">
              Sign in
            </Link>
          </div>
        </>
      ) : null}

      {menuIsOpen ? (
        <div className="overlay" onClick={() => setMenuIsOpen(false)}></div>
      ) : null}

      <Header
        menuIsOpen={menuIsOpen}
        setMenuIsOpen={setMenuIsOpen}
        currentPath={currentFullPath}
        onTabChange={handleTabChange}
      />

      <MainContent component="main">
        <ContentContainer maxWidth="xl">
          <Routes>
            <Route path="/" element={<HomeScreen />} />
            <Route
              path="Profile"
              element={<Profile isMobileOrTablet={isMobileOrTablet} />}
            />
            <Route
              path="Credits"
              element={<Credits isMobileOrTablet={isMobileOrTablet} />}
            />
            <Route
              path="My-Weddings"
              element={<MyWeddings isMobileOrTablet={isMobileOrTablet} />}
            />
            <Route
              path="Terms"
              element={
                <TermsAndConditions isMobileOrTablet={isMobileOrTablet} />
              }
            />
            <Route path="AI_Studio/:projectId" element={<ADS />} />
            <Route path="Ai-Agent" element={<AiPlanner />} />
            {isMobileOrTablet ? null : (
              <Route path="AdminPanel" element={<AdminPanel />} />
            )}

            <Route path="*" element={<Navigate to="/Home" replace />} />
          </Routes>
        </ContentContainer>
      </MainContent>
    </div>
  );
};

export default Home;
